import React, {Fragment} from 'react'
import {
  Button, Box, Flex, TextButton, DropDown, Loading, Icon
} from '@binance/uikit'
import styled from 'styled-components'
import {getLabel} from 'utils/i18n'

const MenuWrap = styled(Flex)`
  a {
    text-decoration-line: none;
  }
`

const Logout = styled(Box)`
  padding: ${props => props.theme.space[3]}px 0;
  width: 100px;
  text-align: center;
  position: relative;
  cursor: pointer;
  .username {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid ${props => props.theme.colors.white};
    font-size: ${props => props.theme.fontSizes[4]}px;
    color: #fff;
  }

  &:hover {
    color: rgba(255, 255, 255, 0.7);
    .username {
      border: 1px solid rgba(255, 255, 255, 0.7);
    }
  }
  &:hover .btn {
    display: flex;
  }
  .btn {
    position: absolute;
    bottom: -40px;
    width: 98px;
    height: 36px;
    display: none;
    justify-content: center;
    align-items: center;
    z-index: 100;
    background: ${props => props.theme.colors.background};
  }
`

const SelectWrap = styled(Box)`
  width: ${({width}) => width};
  background: #1e2126;
  overflow: hidden;
`

const OptionBox = styled(TextButton)`
  float: ${({float}) => float || 'left'};
  display: block;
  width: ${({width}) => width};
  padding: 10px 20px;
  margin: 0;
  white-space: nowrap;
  box-sizing: border-box;

  &.checked,
  &:hover {
    background: rgba(255, 255, 255, 0.04);
  }

  &.checked a {
    color: #f0b90b;
  }

  a {
    color: #fff;

    &:hover {
      color: #f0b90b;
    }
  }
`

MenuWrap.defaultProps = {
  height: 50,
  alignItems: 'center'
}

export default class HeaderMenu extends React.PureComponent {
  _renderLocalesOptions = () => {
    const {locales, path, lang} = this.props
    const currentLang = lang || ''

    return (
      locales
      && Object.entries(locales).map(locale => {
        const [key, val] = locale

        return (
          <OptionBox key={key} width="50%" className={key === currentLang ? 'checked' : ''}>
            <a href={`/${key}/${path}`}>{val}</a>
          </OptionBox>
        )
      })
    )
  }

  _renderInfoOptions = () => {
    const {infoOptions} = this.props

    return infoOptions.map(opt => {
      const {
        name, url, newTarget = false, show = true
      } = opt

      return (
        <Fragment key={name}>
          {show && (
            <OptionBox width="100%" float="none">
              <a target={newTarget ? '_blank' : '_self'} href={url || '/'}>
                {name}
              </a>
            </OptionBox>
          )}
        </Fragment>
      )
    })
  }

  render () {
    const {
      isLogin, urls, username, handleLogout, i18n, locales, lang
    } = this.props

    return (
      <MenuWrap>
        <Flex ml={2} height={16} alignItems="center">
          <DropDown
            tigger="hover"
            overlay={<SelectWrap width="auto">{this._renderInfoOptions()}</SelectWrap>}
          >
            <TextButton
              lineHeight="48px"
              hover="rgba(255, 255, 255, 0.8)"
              color="white"
              ml={1}
              mr={2}
            >
              {getLabel('header-info', i18n)}
              <svg
                style={{marginLeft: 6, verticalAlign: 'middle'}}
                width="6"
                height="4"
                viewBox="0 0 6 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.87006 0.855655L3.30346 3.85338C3.22681 3.9466 3.1163 4 3.00008 4C2.88394 4 2.77343 3.9466 2.69668 3.85338L0.130181 0.855655C0.00489473 0.714313 -0.0338278 0.508304 0.0309405 0.326341C0.0957088 0.144457 0.252008 0.0173411 0.433562 0L5.56455 0C5.7468 0.016602 5.90384 0.1429 5.96853 0.325602C6.03407 0.508304 5.99534 0.713574 5.87006 0.855655Z"
                  fill="#848E9C"
                />
              </svg>
            </TextButton>
          </DropDown>
        </Flex>
        <Loading
          status={isLogin}
          width="125px"
          success={
            <DropDown
              tigger="hover"
              overlay={
                <Flex
                  height="36px"
                  alignItems="center"
                  width="100px"
                  bg="#1E2126"
                  justifyContent="center"
                >
                  <TextButton bg="transparent" onClick={handleLogout}>
                    {i18n['header-logout'] || 'Logout'}
                  </TextButton>
                </Flex>
              }
            >
              <Logout>
                <a className="username" href={(urls && urls.usercenter) || '###'}>
                  {username.substr(0, 2)}
                </a>
              </Logout>
            </DropDown>
          }
          faild={
            <>
              <a href={(urls && urls.login) || '/'}>
                <TextButton hover="rgba(255, 255, 255, 0.7)" mx={6}>
                  {i18n['header-login'] || 'Login'}
                </TextButton>
              </a>
              <a href={(urls && urls.register) || '/'}>
                <Button color="black" bg="primary" mx={6}>
                  {i18n['header-register'] || 'Register'}
                </Button>
              </a>
            </>
          }
        />
        <DropDown
          tigger="hover"
          overlay={<SelectWrap width="240px">{this._renderLocalesOptions()}</SelectWrap>}
        >
          <Flex alignItems="center">
            <Icon color="white" hover="rgba(255, 255, 255, 0.8)" size={16} name="website" />
            <TextButton
              lineHeight="48px"
              hover="rgba(255, 255, 255, 0.8)"
              color="white"
              ml={1}
              mr={2}
            >
              {(locales && locales[lang || 'en']) || 'English'}
            </TextButton>
          </Flex>
        </DropDown>
      </MenuWrap>
    )
  }
}

HeaderMenu.defaultProps = {
  username: '',
  handleLogout: () => {}
}
